module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/dfe35552790fb5ff38c78a43f5e62f30.svg";